import {Deserializable} from "./deserializable.model";

export class SubjectContactEmail {


subject_contact_email_id: number;
subject_contact_email_address: string;
subject_id: number;

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SubjectContactEmail {
    Object.assign(this, input);

    return this;
  }


}



